'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/land-categories/:landCategoryId', null, {
            getAll: {method: 'GET'},
            get: {method: 'GET'},
            create: {method: 'POST'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            enable: {url: 'api/land-categories/:landCategoryId/enable', method: 'PUT'},
            delete: {url: 'api/land-categories/:landCategoryId/delete', method: 'PUT'},
            getDefault: {url: 'api/land-categories/default', method: 'GET'},
            setDefault: {url: 'api/land-categories/:landCategoryId/default', method: 'PUT'},
            isUniqueName: {url: 'api/land-categories/unique/name/:name', method: 'GET'}
        });
    }];